export default __webpack_public_path__ + "images/762c86861b37d423e03a38185aa54ba8-highFiveSvg.svg";